<template>
  <!-- 工作流转换弹窗 -->
  <a-modal
    title="工作流转换"
    :visible="visible"
    @ok="handleConfirm"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    width="520px"
  >
    <a-form>
      <a-form-item
        label="工作流类型"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-select
          :key="`workflow-select-${currentWorkflowType}`"
          v-model:value="workflowType"
          placeholder="请选择工作流类型"
          allow-clear
          style="width: 100%"
        >
          <a-select-option
            v-for="option in availableWorkflowTypes"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div
      style="margin-top: 16px; color: #999; font-size: 12px; line-height: 1.5"
    >
      注:将手环的工作流类型转换为所选类型
    </div>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 工作流转换弹窗组件
 * 功能：提供工作流转换操作的选择界面
 * - 选择要转换的工作流类型（0-AI工作流，1-顺序工作流，2-灵活工作流）
 */
import { convertWorkflowType } from '@/api/system/wristband'

export default {
  name: 'WorkflowConversionModal',
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 手环ID（必填）
    wristbandId: {
      type: [String, Number],
      default: null,
    },
    // 当前工作流类型（0-AI工作流，1-顺序工作流，2-灵活工作流）
    currentWorkflowType: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      // 工作流类型（0-AI工作流，1-顺序工作流，2-灵活工作流）
      workflowType: undefined,
      // 确认按钮加载状态
      confirmLoading: false,
    }
  },
  computed: {
    /**
     * 可用的工作流类型选项
     * 根据当前工作流类型过滤，不显示当前类型
     */
    availableWorkflowTypes() {
      const allTypes = [
        { value: 0, label: 'AI工作流' },
        { value: 1, label: '顺序工作流' },
        { value: 2, label: '灵活工作流' },
      ]
      // 如果当前工作流类型存在，过滤掉当前类型
      // 将 currentWorkflowType 转换为数字进行比较，以处理字符串类型的情况
      if (
        this.currentWorkflowType !== null &&
        this.currentWorkflowType !== undefined &&
        this.currentWorkflowType !== ''
      ) {
        const currentType = Number(this.currentWorkflowType)
        // 确保转换后的值是有效的数字（0, 1, 2）
        if (!isNaN(currentType) && currentType >= 0 && currentType <= 2) {
          return allTypes.filter((type) => type.value !== currentType)
        }
      }
      // 如果没有当前类型或类型无效，返回所有选项
      return allTypes
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开时，重置表单
     */
    visible(newVal) {
      if (newVal) {
        this.workflowType = undefined
        // 调试信息：确认当前工作流类型是否正确传递
        console.log('工作流转换弹窗打开，当前工作流类型:', this.currentWorkflowType)
        console.log('可用选项:', this.availableWorkflowTypes)
      } else {
        // 弹窗关闭时重置
        this.workflowType = undefined
      }
    },
    /**
     * 监听当前工作流类型变化
     */
    currentWorkflowType(newVal) {
      console.log('当前工作流类型变化:', newVal)
      console.log('可用选项:', this.availableWorkflowTypes)
    },
  },
  methods: {
    /**
     * 确认操作
     * 验证选择后调用接口进行工作流转换
     */
    handleConfirm() {
      if (this.workflowType === undefined || this.workflowType === null) {
        this.$message.warning('请选择工作流类型', 3)
        return
      }
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      this.confirmLoading = true
      convertWorkflowType({
        wristbandId: this.wristbandId,
        workflowType: String(this.workflowType),
      })
        .then(() => {
          this.$message.success('工作流转换成功', 3)
          $emit(this, 'confirm', {
            wristbandId: this.wristbandId,
            workflowType: this.workflowType,
          })
          this.handleCancel()
        })
        .catch(() => {
          this.$message.error('工作流转换失败，请稍后重试', 3)
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    /**
     * 取消操作
     * 关闭弹窗并重置表单
     */
    handleCancel() {
      this.workflowType = undefined
      $emit(this, 'cancel')
    },
  },
  emits: ['confirm', 'cancel'],
}
</script>

<style scoped>
/* 选择框样式 - 设置圆角为 4px */
:deep(.ant-select-selector) {
  border-radius: 4px !important;
}
</style>

